import Platform from "../Platform";

export default class App extends Platform {
  constructor() {
    super({
      clientId: process.env.VUE_APP_CLIENT_ID,
      clientSecret: process.env.VUE_APP_CLIENT_SECRET,
      supportedInsertFileTypes: ["svg"],
      features: {
        localStorage: true,
        prototype: false,
        messages: false,
        fillType: false,
        syncFromTool: false
      }
    });
  }

  // file = { format, name, url }
  insertItem(file) {
    console.log("insertItem", file);
    if (file.format === "svg") {
      fetch(file.url)
        .then(res => res.text())
        .then(res => {
          parent.postMessage(
            {
              pluginMessage: {
                type: "insertSVG",
                params: {
                  ...file,
                  svg: res
                }
              }
            },
            "*"
          );
        });
    } else {
      fetch(file.url)
        .then(res => res.arrayBuffer())
        .then(res => {
          const bytes = new Uint8Array(res);
          parent.postMessage(
            {
              pluginMessage: {
                type: "insertRaster",
                params: {
                  ...file,
                  bytes
                }
              }
            },
            "*"
          );
        });
    }
  }

  openURL(url) {
    window.open(url, "_blank");
  }

  // Myscout
  syncSelection(uuid, token) {
    // const endpoint = routeGenerator('syncComponent', { folder: uuid })
    const endpoint =
      process.env.VUE_APP_API_SYNC_COMPONENT ||
      process.env.NUXT_ENV_API_SYNC_COMPONENT;

    parent.postMessage(
      {
        pluginMessage: {
          type: "syncComponents",
          params: {
            endpoint,
            token,
            data: {
              uuid
            }
          }
        }
      },
      "*"
    );
  }
}
